import React from 'react'

import styles from '@components/blocks/large_video_with_content.module.scss'
import ImageAsset from '@components/image_asset'

const LargeVideoWithContent = React.forwardRef(({ fields }, _) => {
  const video = fields.videoLink.fields

  const getImage = image => {
    if (image === undefined) {
      return null
    }

    const positionClass = () => {
      switch (image.imagePosition) {
        case 'Top Left':
          return styles['large_video_with_content__image--top-left']
        default:
          return styles['large_video_with_content__image--bottom-right']
      }
    }

    return <ImageAsset asset={image.image} height="40" width="30" className={positionClass()} />
  }

  return (
    <div className={styles.large_video_with_content}>
      <h2 className={styles.large_video_with_content__title}>{fields.title}</h2>
      <p className={styles.large_video_with_content__subtitle}>{fields.subtitle}</p>
      <div className={styles.large_video_with_content__video}>
        <iframe src={video.url} frameBorder="0" allowFullScreen title={video.name} />
        {fields.positionedImages.map(image => getImage(image.fields))}
      </div>
      <p className={styles.large_video_with_content__body}>{fields.body}</p>
    </div>
  )
})

export default LargeVideoWithContent
